<p-toast key="myKeyUpload"></p-toast>

<div class="documents-layout">
  <section class="documents-panel">
    <div class="documents-toolbar">
      <div><h3>Documenti</h3><p>Gestisci, ordina e scarica i documenti della pagina.</p></div>
      <button pButton type="button" icon="pi pi-trash"
        [label]="'Cancella selezionati (' + selectedDocuments.length + ')'"
        class="p-button-danger p-button-sm" [disabled]="!selectedDocuments.length"
      (click)="onDeleteSelectedFiles()"></button>
    </div>

    @if (imageInfos | async; as documents) {
      @if (documents.length) {
        <div class="list-controls">
          <label class="select-all">
            <input type="checkbox" [checked]="areAllSelected(documents)"
              (change)="toggleAllDocuments(documents, $event)" />
            <span>Seleziona tutti</span>
          </label>
          <span>{{ documents.length }} documenti</span>
        </div>
      }
      @if (documents.length) {
        <div class="document-list">
          @for (file of documents | paginate: { id: 'documents', itemsPerPage: 10, currentPage: documentPage }; track file) {
            <article
              class="document-card" [class.is-selected]="isSelected(file)">
              <div class="document-card-header">
                <label class="document-selector" aria-label="Seleziona documento">
                  <input type="checkbox" [checked]="isSelected(file)" (change)="toggleDocument(file, $event)" />
                </label>
                <div class="document-identity">
                  <strong [title]="file.file_name">{{ file.file_name }}</strong>
                  <span>Documento #{{ file.id }}</span>
                </div>
                <div class="row-actions">
                  <a pButton pRipple icon="pi pi-download" [href]="filesPath + '/' + element.id + '/' + file.file_name"
                    target="_blank" class="p-button-info p-button-sm document-action"
                  pTooltip="Scarica" tooltipPosition="top"></a>
                  <button pButton pRipple type="button" icon="pi pi-trash"
                    class="p-button-danger p-button-sm document-action" (click)="onDeleteFile(file.id)"
                  pTooltip="Cancella" tooltipPosition="top"></button>
                </div>
              </div>
              <div class="document-fields">
                <label class="description-field">
                  <input pInputText type="text" [(ngModel)]="file.description"
                    placeholder="Inserisci una descrizione chiara del documento"
                    aria-label="Descrizione" />
                </label>
                <label class="order-field">
                  <input pInputText type="number" min="0" [(ngModel)]="file.file_order"
                    placeholder="Ordine" aria-label="Numero ordine" />
                </label>
                <button pButton pRipple type="button" icon="pi pi-save" label="Salva modifiche"
                class="p-button-success p-button-sm save-button" (click)="onRowEditSave(file)"></button>
              </div>
            </article>
          }
        </div>
      } @else {
        <div class="empty-state">
          <i class="pi pi-folder-open"></i><strong>Nessun documento</strong><span>Carica uno o più file dal pannello qui accanto.</span>
        </div>
      }
      @if (documents.length > 10) {
        <div class="documents-pagination">
          <pagination-controls id="documents" previousLabel="Precedente" nextLabel="Successiva"
            [autoHide]="true"
          (pageChange)="documentPage = $event"></pagination-controls>
        </div>
      }
    }
  </section>

  <aside class="upload-panel">
    <div class="upload-heading"><span class="upload-icon"><i class="pi pi-cloud-upload"></i></span><div><h3>Carica documenti</h3><p>PDF o DOC, massimo 22 MB per file.</p></div></div>
    <label class="file-picker"><input type="file" accept="application/pdf,.doc" multiple (change)="selectFiles($event)" /><i class="pi pi-plus"></i><span>Scegli uno o più file</span></label>
    @if (previews.length) {
      <div class="selected-files">
        <div class="selected-files-header"><strong>File selezionati</strong><span>{{ previews.length }}</span></div>
        @for (preview of previews; track preview) {
          <div class="selected-file"><i class="pi pi-file"></i><span class="file-name" [title]="preview.name">{{ preview.name }}</span><small>{{ preview.size | filesize }}</small></div>
        }
      </div>
    }
    @for (progressInfo of progressInfos; track progressInfo) {
      <div class="upload-progress"><div><span>{{ progressInfo.fileName }}</span><strong>{{ progressInfo.value }}%</strong></div><p-progressBar [value]="progressInfo.value" [showValue]="false"></p-progressBar></div>
    }
    <button pButton type="button" icon="pi pi-upload" label="Carica documenti" class="p-button-success upload-button" [disabled]="!selectedFiles" (click)="uploadFiles()"></button>
    @if (message.length) {
      <div class="upload-messages" role="status">@for (msg of message; track msg) {
        <div class="upload-message"><i class="pi pi-check-circle"></i><span>{{ msg }}</span></div>
      }</div>
    }
  </aside>
</div>
